/**
 * Resolves "which game am I playing" (a version group) into "which list of
 * Pokémon do I show" (a regional Pokédex).
 */

export function prettify(key) {
  return key.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

/** Regional dexes belonging to a version group, in the API's order. */
export function dexesForVersionGroup(snap, versionGroupKey) {
  const vg = snap.versionGroupByKey.get(versionGroupKey);
  const keys = vg && vg.pokedexKeys.length ? vg.pokedexKeys : ['national'];
  return keys.map((k) => snap.pokedexByKey.get(k)).filter(Boolean);
}

/**
 * The dex to display right now: the one named in settings if it belongs to
 * the current game, otherwise that game's first dex, otherwise National.
 */
export function resolvePokedex(snap, settingsState) {
  const dexes = dexesForVersionGroup(snap, settingsState.versionGroup);
  return (
    dexes.find((d) => d.key === settingsState.pokedex) ||
    dexes[0] ||
    snap.pokedexByKey.get('national')
  );
}

/** Expand a dex's entries into { species, number } rows, dropping unknowns. */
export function dexRows(snap, dex) {
  return dex.entries
    .map(([speciesId, number]) => ({
      species: snap.speciesById.get(speciesId),
      number,
    }))
    .filter((row) => row.species);
}

/** Version groups grouped by generation, for the game picker. */
export function versionGroupsByGeneration(snap) {
  const groups = new Map();
  for (const vg of snap.versionGroups) {
    if (!groups.has(vg.generation)) groups.set(vg.generation, []);
    groups.get(vg.generation).push(vg);
  }
  return [...groups.entries()]
    .sort((a, b) => a[0] - b[0])
    .map(([genId, vgs]) => ({
      generation: snap.generationById.get(genId) || { id: genId, name: `Gen ${genId}` },
      versionGroups: vgs,
    }));
}
